module.exports = __webpack_public_path__ + "static/media/tg.4dd37f93.svg";